module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsJDBAwfhXHhQAAADtJREFUSMdjYBjugBHG2Hl70n9aWuSumsfIwMDAwERvH45aOGrhqIWjFo5aOGrhqIWjFo5aOBQsHP4AAKKsBDBnnevPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_areasnognd.png
// module id = p0O0
// module chunks = 0